import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IProFormaData } from 'views/ProFormaTable/types';

interface ICreateProFormaProps {
    dealId: number;
    selectedOrganizationId: string;
    scenarioId?: number; // Optional parameter
    proFormaModelId?: number; // Optional parameter for asset type, example: 1 for "apartment"
    isWizardFlow?: boolean;

}

const createProForma = async ({
    dealId, selectedOrganizationId, scenarioId, proFormaModelId, isWizardFlow = false,
}: ICreateProFormaProps): Promise<IProFormaData> => {
    const params = new URLSearchParams({
        selectedOrganizationId,
        isWizardFlow: String(isWizardFlow),
    });

    if (scenarioId) params.append('scenarioId', String(scenarioId));
    if (proFormaModelId) params.append('proFormaModelId', String(proFormaModelId));

    const endpoint = `${API_ENDPOINTS.PRO_FORMA(dealId)}?${params.toString()}`;
    const response = await axiosInstance.post(endpoint);
    return response.data;
};

const useCreateProForma = () => useMutation({
    mutationFn: createProForma,
});

export default useCreateProForma;
